import React, { useTransition } from 'react'

import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Stack, Box } from '@mui/material'
import { LockPerson } from '@mui/icons-material'

import { useToast } from '@/contexts/ToastContext'

import { useBiometric } from '@/hooks/useBiometric'
import { biometricUtils } from '@/utils/biometric'

interface BiometricEnablePromptProps {
  open: boolean
  onClose: () => void
}

export const BiometricEnablePrompt: React.FC<BiometricEnablePromptProps> = ({ open, onClose }) => {
  const toast = useToast()
  const biometryMethods = useBiometric()
  const [isPending, startTransition] = useTransition()

  const handleEnable = () => {
    startTransition(async () => {
      try {
        await biometryMethods.authenticate(`Confirme sua identidade para ativar o login biométrico`)
        await biometricUtils.setEnabled(true)
        toast.success(`Login biométrico ativado com sucesso!`)
        onClose()
      } catch (error) {
        if (!biometryMethods.isUserCancel(error)) {
          toast.error('Não foi possível ativar o login biométrico')
        }
      }
    })
  }

  const handleSkip = async () => {
    await biometricUtils.setEnabled(false)
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleSkip} PaperProps={{ sx: { borderRadius: 4, padding: 1 } }}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        <Stack alignItems="center" spacing={1}>
          <LockPerson fontSize="large" />
          <Typography variant="h6" fontWeight="bold">
            Ativar biometria?
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" textAlign="center" color="text.secondary">
          Acesse o aplicativo de forma rápida e segura usando biometria, sem precisar digitar sua senha.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack px={2} py={1} direction="column" spacing={1} width="100%">
          <Button
            variant="contained"
            color="primary"
            sx={{ borderRadius: 20 }}
            onClick={handleEnable}
            disabled={isPending}
            disableElevation
          >
            Ativar biometria
          </Button>
          <Button variant="outlined" fullWidth sx={{ borderRadius: 20 }} onClick={handleSkip} disabled={isPending}>
            Agora não
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}
